import { AxiosInstance } from 'axios';
import DossierUserRepositoryInterface, {
  AgentInterface,
  AgentsCreateInterface,
} from '@/services/Dossier/user/interfaces';

export default class DossierUserRepository implements DossierUserRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAllUsers(): Promise<AgentInterface[]> {
    const response = await this.axios.get('/dossier-controller/users');

    return response.data;
  }

  public async getAllFreeUsers(): Promise<AgentInterface[]> {
    const response = await this.axios.get('/dossier-controller/users/free');

    return response.data;
  }

  public async createUser(data: AgentsCreateInterface): Promise<AgentInterface> {
    const response = await this.axios.post('/dossier-controller/users', data);

    return response.data;
  }

  public async updateUser(userId: string, positionId: number): Promise<void> {
    await this.axios.patch(`/dossier-controller/users/${userId}`, { positionId });
  }

  public async getUser(userId: string): Promise<AgentInterface> {
    const response = await this.axios.get(`/dossier-controller/users/${userId}`);

    return response.data;
  }
}
